// extracted by mini-css-extract-plugin
export default {"container":"LandingPage_container__T5xN1","columnsContainer":"LandingPage_columnsContainer__hTd4-","columnsContainerLeft":"LandingPage_columnsContainerLeft__cUAqe"};